<template>
    <div>
        <Toast></Toast>
        <div class="box-principal">
          <div v-if="!error">
              <i class="pi pi-spin pi-spinner" style="fontSize: 6rem"></i>
              <br/><br/>
              <i>Accediendo...</i>
          </div>
          <div v-if="error">
              {{ $t('err_acceso') }}
              <br/>
              <span @click="$parent.logoutSession()" class="enlace-span">
                  {{ $t('err_url') }}
              </span>
          </div>
        </div>   
    </div>   
</template>



<script>

import ServicioRest from "@/services/ServicioRest";
import Toast from "primevue/toast";

export default {
  name : "loginCursos",
  data() {
    return {
      error: "",
    };
  },
  servicioRest: null,
  created() {
    this.servicioRest = new ServicioRest();

    this.servicioRest.login(this.$route.query.token).then((response) => {
        //se limpia VUEX
         this.$store.dispatch("token/revokeDatos", {});
        //console.log('Realizado el login con resultado');
        //console.log(response);
        //console.log(this.$route.query.pag);
        this.error = "";
        if (response.status == 'OK') {
            // Almacenamos el token en vuex cuando se crea el componente
            if (response.token != null && response.token != "") {
              let emailEstudiante = response.email;
              if (emailEstudiante == null || emailEstudiante == ''){
                  emailEstudiante = response.idCarpeta; //identificador con letra
              }
              this.$store.dispatch("token/setToken", {token: response.token, admin: response.admin, nombreEstudiante: response.nombreEstudiante, emailEstudiante: emailEstudiante, emailSuplanta: response.correoAdmin, uniCodigo: response.uniCodigo});
              this.$toast.add({ severity: "success", summary: "Bienvenido", detail: "Ha entrado en la secretaría virtual de Estudios propios", life: 3000 });

              //Redireccionamos segun lo que venga en this.$route.query.pag
              //de esta forma solo tenemos un login
              if ('solicitarDiplomas' == this.$route.query.pag){
                  this.$router.push({ name: 'SolicitarDiploma'})
              }else if ('listadoDiplomas' == this.$route.query.pag){
                  this.$router.push({ name: 'Diplomas'})
              }else{
                  this.error = "No se encuentra el servicio";
              }


              // if(this.$route.params.nextUrl != null){
              //     this.$router.push(this.$route.params.nextUrl)
              // }
              // else {
              //     this.$router.push({ name: 'Bienvenido'})
              // }

            }
    
        }
    }).catch((error) => {
        this.error = "El usuario o clave introducidos son incorrectos";
    });
  },


  components: {
    Toast,
  },

};

</script>

